import { DashboardFilterDTO } from "../../dto/dashboard/dashboard.dto";
import { WidgetData, WidgetSettings } from "../../components/duna/duna-dashboard/duna-dashboard.component";

export interface DashboardDataState {
  widgetData: {
    [key: string]: {
      data: any;
      lastUpdated: number;
      loading: boolean;
      error: any;
    }
  };
  userWidgetConfigs: {
    [userId: string]: {
      [widgetId: string]: {
        settings: WidgetSettings;
        position?: {
          x: number;
          y: number;
          cols: number;
          rows: number;
        };
        lastUpdated: number;
      }
    }
  };
  currentUserId: string | null;
}

export const initialDashboardDataState: DashboardDataState = {
  widgetData: {},
  userWidgetConfigs: {},
  currentUserId: null
};

// Helper function to generate a cache key
export function generateCacheKey(widgetType: string, dataSource: string, filters?: DashboardFilterDTO): string {
  return `${widgetType}:${dataSource}:${JSON.stringify(filters || {})}`;
}

// Helper function to get user-specific widget key
export function getUserWidgetKey(userId: string, widgetId: string): string {
  return `${userId}:${widgetId}`;
} 